import { useStore } from 'app/context';
import { normalizeFilename } from 'app/utils';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { Button } from './Button';
import { IBerichtePanelHeaderProps } from './TreePanelHeader';
import { SavedBerichtModel } from 'app/models/saved.bericht.model';

export interface IDownloadPdf {
    supportSavedReports?: boolean;
}

export interface IDownloadPdfFull extends IBerichtePanelHeaderProps {
    supportSavedReports?: boolean;
}

export const DownloadPdf = observer((props: IDownloadPdfFull) => {
    const { pdfStore, kvBnrSavedBerichteStore, uiStore, session } = useStore();
    const { treeStore } = props;
    const [savedReportFileName, setSavedReportFileName] = useState('');

    const [pdfSaved, setPdfSaved] = useState(false);

    const currenReportPath = treeStore.menu.current?.path;

    const [savedBerichte, setSaveBerichte] = useState<SavedBerichtModel[]>([]);

    useEffect(() => {
        if (props.supportSavedReports) {
            kvBnrSavedBerichteStore.findAll().then(res => {
                const currRepPath = 'berichte/' + (currenReportPath ? currenReportPath.toLowerCase() : '');
                const filtered = kvBnrSavedBerichteStore._items.filter((x) => x.reportPathWithoutParms.toLowerCase() === currRepPath);
                setSaveBerichte(filtered);
                console.log(savedBerichte);
            });
        }
    }, [props.supportSavedReports]);


    const onSelectSavedBericht = async (e: React.ChangeEvent<HTMLSelectElement>) => {
        const id = e.target.value;
        if (id) {
            const bericht = savedBerichte.find((b) => b.id === id);
            uiStore.setShowPdfTitle(bericht?.fileName || 'Bericht');
            const url = await pdfStore.getSavedPdfLink(id);
            uiStore.setShowPdf(url);
            e.target.value = '';
        }
    };

    const downloadPdf = () => {
        const currentPath = window.location.hash.substring(2);
        let fileName = 'Bericht';
        if (treeStore) {
            const repName = treeStore.menu.current!.parents.map((x) => x.name).join('-');
            fileName = normalizeFilename(repName);
        }
        pdfStore.printPdf2(currentPath, fileName);
    };

    // const savePdf = async () => {
    //     setPdfSaved(false);
    //     const currentPath = window.location.hash.substring(2);
    //     await pdfStore.printAndSavePdf2(currentPath, savedReportFileName, currenReportPath);
    //     setPdfSaved(true);

    // };

    return (
        <>
            <div className="grid is-col-auto justify-start align-center">
                <Button className="button is-text" onClick={downloadPdf}>
                    Download PDF
                </Button>
                {/* {pdfSaved && <span id="pdf-saved">saved</span>}
                len: {savedBerichte.length} */}
                {props.supportSavedReports && savedBerichte.length > 0 && (
                    <select className="input" onChange={onSelectSavedBericht} defaultValue="">
                        <option value="" disabled>
                            Gespeicherte Berichte
                        </option>
                        {savedBerichte.map((bericht) => (
                            <option key={bericht.id} value={bericht.id}>
                                {bericht.fileName} ({bericht.createdFormatted})
                            </option>
                        ))}
                    </select>
                )}
                {/* {props.supportSavedReports && (
                    <>
                        {(session.isAdmin || session.isSuperAdmin) && (
                            <>
                                <input
                                    type="text"
                                    id="dvs-saved-report-filename"
                                    className="input"
                                    placeholder="Berichtsname"
                                    value={savedReportFileName}
                                    onChange={(e) => setSavedReportFileName(e.target.value)}
                                />
                                <Button id="dvs-save-report-button" className="button is-primary is-outlined" onClick={savePdf} disabled={savedReportFileName.length < 6}>
                                    Save PDF
                                </Button>
                            </>
                        )}
                    </>
                )} */}
            </div>
        </>
    );
});
